import { useQuery } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { pandaAccessToken } from './useGetDocuments'

// Adjust the function to accept a templateId parameter
const getTemplates = async (templateId?: string, slackUserId?: string) => {
  const url = templateId
    ? `${baseUrl}/aws/pandadocuments/templates/${templateId}`
    : `${baseUrl}/aws/pandadocuments/templates`

  try {
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${pandaAccessToken}`,
        'X-Slack-User-ID': slackUserId, // Custom header
      },
    })

    return response.data
  } catch (error) {
    if ((error as any).response && (error as any).response.status === 401) {
      // Handle 401 error by calling the refresh token endpoint
      const refreshResponse = await axios.post(`${baseUrl}/refresh-panda-token`, { slackUserId })
      const newAccessToken = refreshResponse.data.pandaAccessToken

      // Retry the original request with the new access token
      const retryResponse = await axios.get(url, {
        headers: { Authorization: `Bearer ${newAccessToken}` },
      })

      return retryResponse.data
    } else {
      throw new Error(
        (error as any).response?.data?.message ||
          error.message ||
          'An unexpected error occurred fetching template details.'
      )
    }
  }
}

// Use this function for fetching either all templates or details for a specific template
export const useGetTemplates = (templateId?: string) => {
  return useQuery({
    queryKey: ['pandaTemplates', templateId], // Use templateId as part of the query key for cache differentiation
    queryFn: () => getTemplates(templateId),
  })
}
